export { fetchPatientDetails, updatePatient, createPatient } from "./patient-service";